import MONSTRO_9 from "url:../sprites/cegodongo.png";
import SOM_1 from "url:../sfx/aaiiinnnn.m4a";

export default {
  attack: 1,
  life: 7,
  speed: 6,
  agility: 7,
  weapon: 1,
  image: MONSTRO_9,
  sound: SOM_1,
};
